import { type TradeDirection } from "./trade";

export interface ChangeIndicatorValues {
  from: number;
  to: number;
}

export enum ComboPricesRowType {
  Summary = "summary",
  TotalSummary = "totalSummary",
  OptionsLeg = "optionsLeg",
  PerpsLeg = "perpsLeg",
}

export interface PricesTableEntry {
  instrument: string;
  rowType: ComboPricesRowType;
  hasEnoughLiquidity?: boolean;
  side?: TradeDirection;
  price?: number;
  size?: number;
  available?: number;
  imr?: ChangeIndicatorValues | number;
  mmr?: ChangeIndicatorValues | number;
  delta?: ChangeIndicatorValues | number;
  gamma?: ChangeIndicatorValues | number;
  vega?: ChangeIndicatorValues | number;
  theta?: ChangeIndicatorValues | number;
  limitNetPrice?: string;
  netPremium?: number;
  estimatedExecutionPrice?: number;
  markPrice?: number;
  interestRate?: number;
  indexPrice?: number;
  iv?: number;
  deltaType?: DeltaType;
  deltaFactorKey?: DeltaFactorKey;
  maxDeltaSlippageFactor?: number;
  maxBuyPriceAfterSlippage?: number;
  minSellPriceAfterSlippage?: number;
}

export type DeltaFactorKey =
  | "highDeltaSlippageFactor"
  | "midDeltaSlippageFactor"
  | "lowDeltaSlippageFactor";

export type DeltaType = "Low" | "Mid" | "High";

export interface ComboDeltaInfo {
  deltaFactorKey: DeltaFactorKey;
  deltaType: DeltaType;
  maxDeltaSlippage: number;
  maxDeltaSlippageFactor: number;
}
